module.exports = __webpack_public_path__ + "static/img/samajuri (32).fae47b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (32).jpg
// module id = +H2W
// module chunks = 0